<template>
  <!-- 文章列表 -->
  <div class="articleList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['文章管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增文章</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">文章分类：</label>
        <el-cascader
          style="width: 300px; margin-right: 10px"
          v-model="searchForm.sortId"
          :options="sortList"
          :props="sortProps"
          placeholder="文章分类"
        ></el-cascader>
        <label class="label">文章状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="文章状态"
          style="width: 100px; margin-right: 10px"
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="已启用" value="2"></el-option>
          <el-option label="已禁用" value="1"></el-option>
        </el-select>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 10px"
          clearable
          placeholder="文章名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" type="index">
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="文章编号"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        align="center"
        show-overflow-tooltip
        label="文章标题"
      >
      </el-table-column>
      <el-table-column
        prop="sortName"
        label="分类名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="author"
        label="作者"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="unitName"
        label="单位名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="tags"
        label="标签"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="摘要"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="上次更新时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">已禁用</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已启用</el-tag>
          <el-tag type="info" v-if="scope.row.status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status != 0"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-show="scope.row.status == 1"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 2)"
            >启用</el-button
          >
          <el-button
            v-show="scope.row.status == 2"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 1)"
            >禁用</el-button
          >
          <el-button
            v-show="scope.row.status != 0"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 0)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "articleList",
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        name: "",
        status: "9",
        sortId: "0",
      },
      // 分类列表
      sortProps: {
        value: "id",
        label: "title",
        children: "childs",
        checkStrictly: true,
        emitPath: false,
      },
      sortList: [{ id: "0", title: "全部" }],
    };
  },
  mounted() {
    this.getSort();
    this.getTableData();
  },
  methods: {
    updata() {
      this.getSort();
      this.getTableData();
    },
    /** 获取文章分类 */
    getSort() {
      let data = {
        navType: "HomePage",
        status: 2,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "post",
        data: data,
      })
        .then((res) => {
          this.sortList = [];
          if (res.success) {
            this.changeArr(res.list || []);
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**递归调用函数 */
    changeArr(list) {
      let obj = {};
      obj[0] = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let itemData = this.setTabelItem(item);
        if (item.rank == 1) {
          obj[0].push(itemData);
        } else {
          if (!obj[item.parent_id]) {
            obj[item.parent_id] = [];
          }
          obj[item.parent_id].push(itemData);
        }
      }
      for (let i = 0; i < obj[0].length; i++) {
        for (let j = 0; j < (obj[obj[0][i].id] || []).length; j++) {
          obj[obj[0][i].id][j].childs = obj[obj[obj[0][i].id][j].id];
        }
        obj[0][i].childs = obj[obj[0][i].id];
      }
      this.sortList = [{ id: "0", title: "全部" }].concat(obj[0]);
    },
    // 设置分类数据格式
    setTabelItem(item) {
      return {
        id: item.Id,
        title: item.title,
        rank: item.rank + "",
        sort: item.sort_id,
        status: item.status,
        channelId: item.channel_id,
        parentId: item.parent_id + "",
        name: item.name,
        icon: item.icon_url,
        navType: item.nav_type,
      };
    },
    /**获取表格 */
    getTableData() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        categoryId: this.searchForm.sortId || 0,
        searchVal: this.searchForm.name,
        status: this.searchForm.status,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      this.$request({
        url: "Article/GetArticleMessage",
        method: "post",
        data: data,
      })
        .then((res) => {
          console.log(res);
          this.allPage = 1;
          this.tableData = [];
          if (res.success) {
            this.allPage = res.toTal;
            this.tableData = (res.list || []).map((item) => ({
              id: item.MsgId,
              title: item.Title,
              author: item.Author,
              sortId: item.CategoryId,
              sortName: item.CategoryName,
              tags: item.Tags,
              remark: item.ZhaiYao,
              status: item.Status,
              sort: item.SortId,
              unitName: item.Organization,
              time: item.Lastmodifytime,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },

    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },

    /**更改状态 */
    handleStatus(row, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 0) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            msgId: row.id,
            status: status,
          };
          this.$request({
            url: "Article/UpdateArticleStatus",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify({ id: row.id }));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "addArticle",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
  },
};
</script>

<style scoped>
.articleList {
  width: 100%;
  height: 100%;
}
</style>
